import {
  QUIZ_LENGTH,
  getQuestionById,
  validateQuestionSet,
} from "./questions";

export type Tendency =
  | "明显偏 P"
  | "比较偏 P"
  | "弹性区"
  | "比较偏 J"
  | "明显偏 J";

export type AnswerScale = 5 | 7;

export const CURRENT_ANSWER_SCALE: AnswerScale = 7;

export function isAnswerScale(value: unknown): value is AnswerScale {
  return value === 5 || value === 7;
}

export function validateAnswers(
  value: unknown,
  answerScale: AnswerScale = 5,
): value is number[] {
  return (
    Array.isArray(value) &&
    value.length === QUIZ_LENGTH &&
    value.every(
      (answer) =>
        Number.isInteger(answer) && answer >= 0 && answer < answerScale,
    )
  );
}

export function calculateScore(
  questionIds: readonly number[],
  answers: readonly number[],
  answerScale: AnswerScale = 5,
): number {
  if (
    !validateQuestionSet(questionIds) ||
    !validateAnswers(answers, answerScale)
  ) {
    throw new Error(
      `A balanced set of 16 question IDs and 16 answers from 0 to ${answerScale - 1} is required.`,
    );
  }

  const midpoint = (answerScale - 1) / 2;
  const total = answers.reduce((sum, answer, index) => {
    const question = getQuestionById(questionIds[index] as number);
    if (!question) {
      return sum;
    }
    const leftToRight = answer - midpoint;
    const jPoints = question.jSide === "right" ? leftToRight : -leftToRight;
    return sum + jPoints;
  }, 0);

  return Math.round((total / (QUIZ_LENGTH * midpoint)) * 100);
}

export function getTendency(score: number): Tendency {
  if (score <= -50) return "明显偏 P";
  if (score <= -20) return "比较偏 P";
  if (score < 20) return "弹性区";
  if (score < 50) return "比较偏 J";
  return "明显偏 J";
}

export function formatScore(score: number): string {
  return score > 0 ? `+${score}` : String(score);
}
